
import { MechanicalAspectEntityDecoratorBase } from './mechanical-aspect.decorator.base';


export class MechanicalAspectEntityDecorator extends MechanicalAspectEntityDecoratorBase {
  constructor() {
    super();
  }
}



